// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__36tGW","errors":"Errors_errors__4yW55"};